import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useUserEventLogger } from '@repo/tracking-service';
import { Drawer, DrawerBody, DrawerContent, DrawerHeader, IconButton } from '@repo/ui';

interface TermDrawerProps {
  link: string;
  closeEventName?: string;
}

export const TermDrawer = NiceModal.create(({ link, closeEventName }: TermDrawerProps) => {
  const modal = useModal();
  const { sendClickEvent } = useUserEventLogger();
  return (
    <Drawer open={modal.visible}>
      <DrawerContent disableOutsideClick isFullScreen>
        <DrawerHeader>
          <IconButton
            variant={'main'}
            size={'small'}
            iconType={'close'}
            onClick={() => {
              if (closeEventName) sendClickEvent(closeEventName);
              modal.hide();
            }}
            aria-label={'close-terms-modal'}
          />
        </DrawerHeader>
        <DrawerBody className={'h-full'}>
          <iframe className={'h-full p-0'} src={link} title={'bznav_refund_term_iframe'} />
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
});
